import { all, fork } from 'redux-saga/effects';

import { achievementsRootSaga } from './achievements/achievementsSagas';
import { adRewardRootSaga } from './adReward/adRewardSagas';
import { authRootSaga } from './auth/authSagas';
import { bonusRootSaga } from './bonus/bonusSagas';
import { chatRootSaga } from './chat/chatSagas';
import { duelsRootSaga } from './duels/duelsSagas';
import { friendsRootSaga } from './friends/friendsSagas';
import { i18nRootSaga } from './i18n/i18nSagas';
import { iapSaga } from './iap/iapSagas';
import { inviteRootSaga } from './invites/inviteSaga';
import { miniGamesRewardsRootSaga } from './jackpot/miniGamesRewardsSaga';
import { lobbyRootSaga } from './lobby/lobbySagas';
import { miniGamesRootSaga } from './miniGames/miniGamesSagas';
import { missionsRootSaga } from './missions/missionsSagas';
import { packageRootSaga } from './packages/packagesSagas';
import { rankingsRootSaga } from './rankings/rankingsSagas';
import { roomSocketSaga } from './room/roomSagas';
import { tournamentsRootSaga } from './tournaments/tournamentsSagas';
import { notificationsRootSaga } from './userNotifications/notificationsSagas';

export function* rootSaga() {
	yield all([
		fork(roomSocketSaga),
		fork(authRootSaga),
		fork(lobbyRootSaga),
		fork(packageRootSaga),
		fork(bonusRootSaga),
		fork(i18nRootSaga),
		fork(notificationsRootSaga),
		fork(inviteRootSaga),
		fork(rankingsRootSaga),
		fork(tournamentsRootSaga),
		fork(miniGamesRootSaga),
		fork(miniGamesRewardsRootSaga),
		fork(iapSaga),
		fork(adRewardRootSaga),
		fork(missionsRootSaga),
		fork(friendsRootSaga),
		fork(achievementsRootSaga),
		fork(duelsRootSaga),
		fork(chatRootSaga),
	]);
}
